import React from 'react';
import { Card, Table, Row, Col } from 'react-bootstrap';
import moment from 'moment';

const formatarData = (data) => {
  if (!data) return '—';
  const m = moment(data);
  if (!m.isValid() || m.year() < 1901) return '—';
  return m.format('DD/MM/YYYY');
};

const CardCobranca = ({ cobranca }) => {
  const c = cobranca != null ? cobranca : {};

  const linhas = [
    { label: 'Negativações', dados: c.negativacoes },
    { label: 'Ref. Parcial', dados: c.refinanciamento_parcial },
    { label: 'Ref. Geral', dados: c.refinanciamento_geral },
    { label: 'Tribunal Arbitral', dados: c.tribunal_arbitral },
    { label: 'Not. Extrajudicial', dados: c.notificacao_extrajudicial },
    { label: 'Judicial', dados: c.judicial },
    { label: 'Devoluções', dados: c.devolucoes },
  ];

  return (
    <Card className="shadow-sm h-100">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <strong>Negativações / Ações Jurídicas</strong>
      </Card.Header>
      <Card.Body className="p-0">
        {/* Desktop */}
        <div className="d-none d-md-block">
          <Table bordered size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Tipo</th>
                <th className="text-right">Qtd</th>
                <th className="text-right">Última Data</th>
              </tr>
            </thead>
            <tbody>
              {linhas.map((linha) => {
                const dados = linha.dados != null ? linha.dados : {};
                return (
                  <tr key={linha.label}>
                    <td>{linha.label}</td>
                    <td className="text-right">{dados.quantidade != null ? dados.quantidade : 0}</td>
                    <td className="text-right">{formatarData(dados.ultima_data)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        {/* Mobile */}
        <div className="d-md-none">
          {linhas.map((linha) => {
            const dados = linha.dados != null ? linha.dados : {};
            return (
              <div key={linha.label} className="border-bottom p-2">
                <Row className="align-items-center">
                  <Col xs={6}>
                    <div className="font-weight-bold" style={{ fontSize: '0.85rem' }}>{linha.label}</div>
                  </Col>
                  <Col xs={2} className="text-center">
                    <div className="font-weight-bold">{dados.quantidade != null ? dados.quantidade : 0}</div>
                  </Col>
                  <Col xs={4} className="text-right">
                    <small className="text-muted">{formatarData(dados.ultima_data)}</small>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CardCobranca;
